import { render } from "./AssignRatersDropdown.vue?vue&type=template&id=a80eabb0&scoped=true"
import script from "./AssignRatersDropdown.vue?vue&type=script&lang=ts"
export * from "./AssignRatersDropdown.vue?vue&type=script&lang=ts"

import "./AssignRatersDropdown.vue?vue&type=style&index=0&id=a80eabb0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-a80eabb0"
/* custom blocks */
import block0 from "./AssignRatersDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script